import axios from "./axios";

class Routes {
  async fetch_wastes(page, limit, order) {
    const response = await axios.get(`/fetch_wastes`, {
      params: { page, limit, order }
    });
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async edit_waste_label(wasteId, data) {
    const response = await axios.patch(`/edit_waste_label/${wasteId}`, data)

    if (response && response.response?.data) return response.response.data;
    return response.data;
  }
}

export default new Routes();